import { Table } from "antd";
import React from "react";
import { formatPassedAt } from "../PassedQueueDrawer/PassedQueueDrawer";

// Antrian yang selesai saat sebuah antrian berstatus Passed. Setiap baris
// menaikkan queues_passed_count antrian tersebut (finished_at waktu lokal klinik).
const columns = [
  {
    title: "No Antri",
    dataIndex: "queue_number",
    key: "queue_number",
    width: 100,
    render: (text) => <span>{text ?? "-"}</span>,
  },
  {
    title: "Nama",
    dataIndex: "child_name",
    key: "child_name",
    render: (text) => <span>{text || "-"}</span>,
  },
  {
    title: "Waktu Selesai",
    dataIndex: "finished_at",
    key: "finished_at",
    width: 140,
    render: (text) => <span>{formatPassedAt(text)}</span>,
  },
];

const FinishedSincePassedTable = ({ items }) => (
  <Table
    size="small"
    dataSource={Array.isArray(items) ? items : []}
    columns={columns}
    rowKey="queue_id"
    pagination={false}
    locale={{ emptyText: "Belum ada antrian yang selesai sejak terlewat" }}
  />
);

export default FinishedSincePassedTable;
